module.exports = __webpack_public_path__ + "img/js-banner-2.8cb13332.png";